import { authStorage } from '../storages';
import { getAuthQueryParams } from '../helpers';

export async function checkQueryAuthParams() {
  const authQueryParams = getAuthQueryParams();
  if (!authQueryParams.accessToken || !authQueryParams.refreshToken) return;

  await authStorage.setJwtAuthParams({
    access: authQueryParams.accessToken,
    refresh: authQueryParams.refreshToken,
  });
}
